export const CURRENCY_SYMBOL = { TRY: "₺", USD: "$", EUR: "€" };
export const CURRENCIES = ["TRY", "USD", "EUR"];
export const VAT_RATES = [0, 1, 10, 20];
export const UNITS = ["adet", "m2", "mtül", "mt", "kg", "paket", "kutu"];

export function formatMoney(amount, currency = "TRY") {
  const num = Number(amount || 0);
  const formatted = num.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const sym = CURRENCY_SYMBOL[currency] || currency;
  return `${formatted} ${sym}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return "-"; }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "-"; }
}

/**
 * Turkish duration string between two ISO timestamps.
 * If endIso is null/undefined → duration up to now (live).
 * Examples: "45dk", "3sa 12dk", "2g 4sa", "az önce"
 */
export function formatDuration(startIso, endIso) {
  if (!startIso) return "-";
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : Date.now();
  const ms = Math.max(0, end - start);
  const totalMin = Math.floor(ms / 60000);
  if (totalMin < 1) return "az önce";
  const days = Math.floor(totalMin / 1440);
  const hours = Math.floor((totalMin % 1440) / 60);
  const mins = totalMin % 60;
  if (days > 0) return hours > 0 ? `${days}g ${hours}sa` : `${days}g`;
  if (hours > 0) return mins > 0 ? `${hours}sa ${mins}dk` : `${hours}sa`;
  return `${mins}dk`;
}

export const KIND_LABEL = {
  customer: "Müşteri",
  supplier: "Tedarikçi",
  employee: "Çalışan",
  cash_register: "Kasa",
  external: "Harici",
};

export const KIND_ROUTE = {
  customer: "musteriler",
  supplier: "tedarikciler",
  employee: "calisanlar",
  cash_register: "kasalar",
};

export const CATEGORY_LABEL = {
  payment: "Ödeme",
  receipt: "Tahsilat",
  virman: "Virman",
  salary: "Maaş",
  bonus: "Bonus",
  loan: "Çalışana Borç Ver",
  borrow_from_employee: "Çalışana Borçlan",
  repay_to_employee: "Çalışana Borcumu Geri Öde",
  manual_deposit: "Kasa Giriş",
  manual_withdraw: "Kasa Çıkış",
  invoice_sale: "Satış Faturası",
  invoice_purchase: "Alış Faturası",
};
